//Production
// const url = { baseURL: 'https://api.recykle.in/api/' };


// Dev
 const url = { baseURL: 'https://recykle-api.kcdev.xyz/api/' };

export default url;



// WEBPACK FOOTER //
// ./src/components/common/BaseURL.js